import auth0 from 'auth0-js';
import { canUseLocalStorage } from './canuse';
import { logAmplitudeEvent } from './analytics';

const AUTH0_DOMAIN = 'gamelynx.auth0.com';
const AUTH0_CLIENT_ID = 'E1ZT6s6WiqrZiMOvNHihVGEQ5vvyLiOk';
export const PRE_SIGN_IN_URL_STORAGE_KEY = 'PRESIGNINURL';

let origin = 'unknown';
if (typeof window !== 'undefined') {
  origin = `${window.location.protocol}//${window.location.host}`;
}

export default class Auth {
  auth0 = new auth0.WebAuth({
    domain: AUTH0_DOMAIN,
    clientID: AUTH0_CLIENT_ID,
    redirectUri: `${origin}/auth0_callback`,
    audience: `https://${AUTH0_DOMAIN}/api/v2/`,
    responseType: 'token id_token',
    scope: 'openid profile email'
  });

  login = () => {
    this.auth0.authorize();
  };

  logout = () => {
    if (canUseLocalStorage()) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('expires_at');
      localStorage.removeItem('user');
    }
  };

  handleAuthentication = callback => {
    if (typeof window !== 'undefined') {
      this.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);
          logAmplitudeEvent('auth0_session_start_success');
          this.auth0.client.userInfo(authResult.accessToken, (userInfoErr, user) => {
            callback(user);
          });
        } else {
          callback(null);
          logAmplitudeEvent('auth0_session_start_failure', { err });
        }
      });
    }
  };

  isAuthenticated = () => {
    if (canUseLocalStorage()) {
      const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
      return new Date().getTime() < expiresAt;
    }
  };

  setSession = authResult => {
    const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
    if (canUseLocalStorage()) {
      localStorage.setItem('access_token', authResult.accessToken);
      localStorage.setItem('id_token', authResult.idToken);
      localStorage.setItem('expires_at', expiresAt);

      this.auth0.client.userInfo(authResult.accessToken, (err, user) => {
        localStorage.setItem('user', JSON.stringify(user));
      });
    }
  };

  getUser = () => {
    if (canUseLocalStorage()) {
      if (localStorage.getItem('user')) {
        return JSON.parse(localStorage.getItem('user'));
      }
    }
  };

  getUserName = () => {
    if (this.getUser()) {
      return this.getUser().name;
    }
  };
}

const auth = new Auth();
export { auth };
